import { createFileRoute } from "@tanstack/react-router";
import { PlaceholderShell } from "@/components/admin/PlaceholderShell";
import { AdminSubNav, CHATBOT_TABS } from "@/components/admin/AdminSubNav";

export const Route = createFileRoute("/admin/chatbot/")({
  head: () => ({
    meta: [
      { title: "AI chat bot · Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ChatbotOverview,
});

function ChatbotOverview() {
  return (
    <div>
      <AdminSubNav tabs={CHATBOT_TABS} />
      <PlaceholderShell
        title="AI chat bot"
        description="The investor-facing assistant on the public site: coverage, volume, and quality."
        checklist={[
        "Conversations and answer rate this week",
        "Top unanswered questions",
        "Escalation to loan officer rate",
        "Model and tone settings",
        ]}
      />
    </div>
  );
}
